import { Divider, Flex, FlexProps, Text, Title } from "@mantine/core";

interface IProps extends FlexProps {
  name: string | React.ReactNode;
  value?: string;
  icon: React.ReactNode;
  isNegative?: boolean;
}

const InfoCards = ({ name, value, icon, isNegative, ...props }: IProps) => {
  return (
    <Flex
      w="100%"
      align="center"
      justify={"start"}
      p="20px 30px"
      gap="10px"
      h="fit-content"
      style={{
        borderRadius: "6px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
      }}
      {...props}
    >
      {icon}
      <Divider
        orientation="vertical"
        h="30px"
        w="1px"
        color="basic.2"
        style={{ alignSelf: "center" }}
      />
      <Flex justify="space-between" direction="column" h="100%" w="fit-content">
        <Text
          className="titleName"
          fw={700}
          fz={20}
          lh="31px"
          color={
            isNegative === undefined
              ? "basic.4"
              : isNegative
              ? "alerts.0"
              : "alerts.2"
          }
          style={{
            width: "fit-content",
            whiteSpace: "nowrap",
          }}
        >
          {!!value ? value : "--"}
        </Text>
        <Title
          ff="Barlow"
          fw={500}
          fz={14}
          lh="22px"
          color="basic.5"
          w="fit-content"
          style={{
            wordBreak: "break-word",
            whiteSpace: "nowrap",
          }}
        >
          {name}
        </Title>
      </Flex>
    </Flex>
  );
};

export default InfoCards;
